import {
  AnyTeamPublicCacheEntityVersion,
  Collections,
  DEFAULT_TEAM_PUBLIC_CACHE_SETTINGS,
  FirestoreEntity,
  Mapper,
  TeamPublicCache,
} from '@uploadcam/common';
import { CollectionReference, doc, Firestore, getDoc } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class GetTeamPublicCacheByIdInteractor {
  private readonly collection: CollectionReference<AnyTeamPublicCacheEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly mapper: Mapper<
      FirestoreEntity<AnyTeamPublicCacheEntityVersion>,
      TeamPublicCache
    >,
  ) {
    this.collection = getCollectionRef(this.db, Collections.TeamsPublicCache);
  }

  public async execute(id: string): Promise<TeamPublicCache> {
    const teamRef = doc(this.collection, id);
    const teamDoc = await getDoc(teamRef);
    const teamData = teamDoc.data();

    if (teamData) {
      return this.mapper.map(FirestoreEntity.from(teamDoc));
    } else {
      return new TeamPublicCache(id, new Date(), '', DEFAULT_TEAM_PUBLIC_CACHE_SETTINGS);
    }
  }
}
